import ExcelFormulas from './ExcelFormulas';

const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

function CalculatePayments(type, title, investmentSize, financingTime, startYear,
                           loanInterest, greenLoanInterest, leasingInterest,
                           leasingResidual, greenLeasingInterest, greenLeasingResidual,
                           rentInitialRent, rentIndexing, rentRedemptionValue,
                           shortRentInitialRent, shortRentIndexing, shortRentRedemptionValue,
                           leasingContractLength, greenLeasingContractLength) {
  let years = {};
  let residualValue = (type === 'leasing') ? leasingResidual / 100 :
                      (type === 'vihrea-leasing') ? greenLeasingResidual / 100 : 0;
  let leasingTime = (type === 'leasing') ? leasingContractLength :
                    (type === 'vihrea-leasing') ? greenLeasingContractLength : 0;
  let leasingMonths = leasingTime * 12;
  let finaTime = (type === 'leasing' || type === 'vihrea-leasing') ? Math.ceil(leasingMonths / 12) : financingTime;
  startYear = 1;
  let endYear = startYear + finaTime;
  let leasingPaid = {paid: 0};
  investmentSize *= 1000000;
  loanInterest /= 100;
  greenLoanInterest /= 100;
  leasingInterest /= 100;
  greenLeasingInterest /= 100;
  rentRedemptionValue *= 1000000;
  shortRentRedemptionValue *= 1000000;
  rentInitialRent /= 100;
  shortRentInitialRent /= 100;
  rentIndexing /= 100;
  shortRentIndexing /= 100;

  for (let i = startYear; i < endYear; i++) {
    let yearValues;
    switch (type) {
      case 'pitkaaikainen-vuokra-yli-5-vuotta':
        yearValues = _calculateRentMonths(investmentSize, endYear, i, i - startYear, rentInitialRent, rentIndexing, rentRedemptionValue);
        break;
      case 'lyhytaikainen-vuokra-alle-5-vuotta':
        yearValues = _calculateRentMonths(investmentSize, endYear, i, i - startYear, shortRentInitialRent, shortRentIndexing, shortRentRedemptionValue);
        break;
      case 'laina':
        yearValues = _calculateLoanMonths(investmentSize, financingTime, i - startYear, loanInterest);
        break;
      case 'vihrea-rahoitus':
        yearValues = _calculateLoanMonths(investmentSize, financingTime, i - startYear, greenLoanInterest);
        break;
      case 'leasing':
        yearValues = _calculateLeasingMonths(investmentSize, endYear, leasingMonths, i, i - startYear, leasingPaid, leasingInterest, residualValue);
        break;
      case 'vihrea-leasing':
        yearValues = _calculateLeasingMonths(investmentSize, endYear, leasingMonths, i, i - startYear, leasingPaid, greenLeasingInterest, residualValue);
        break;
      default:
        break;
    }

    years[i] = {"months": yearValues, "sum": Object.values(yearValues).reduce(sumReducer)};
  }

  let sum = Object.values(years).map(o => o.sum).reduce(sumReducer);
  // Round sum to closest thousands to improve UI readability, change later if needed
  return {"title": title, "years": years, "sum": Math.round(sum / 1000) * 1000};
}

function _calculateRentMonths(investmentSize, endYear, year, yearIndex, alkutuottovaade, indeksointi, lunastusArvo) {
  let months = {};

  for (let i = 1; i <= 12; i++) {
    let addedLunastusArvo = (year === (endYear - 1) && i === 12) ? lunastusArvo : 0;
    months[i] = Math.round(investmentSize * (alkutuottovaade / 12) * Math.pow(1 + indeksointi, yearIndex))
                    + addedLunastusArvo;
  }

  return months;
}

function _calculateLoanMonths(investmentSize, financingTime, yearIndex, interestRate) {
  let months = {};
  let monthlyPayment = Math.round(investmentSize / (financingTime * 12)); // Loan payment without interest

  for (let i = 1; i <= 12; i++) {
    let paidSum = (i - 1 + (yearIndex * 12)) * monthlyPayment;
    let monthlyIntrest = Math.round((investmentSize - paidSum) * (interestRate / 12));
    months[i] = monthlyPayment + monthlyIntrest;
  }

  return months;
}

function _calculateLeasingMonths(investmentSize, endYear, leasingMonths, year, yearIndex, paid, interestRate, residualValue) {
  let months = {};
  let prevYearMonths = yearIndex * 12;
  let interestPerMonth = interestRate / 12;
  let monthsRemainingThisYear = (endYear !== (year + 1)) ? 12 : leasingMonths - prevYearMonths;

  for (let i = 1; i <= monthsRemainingThisYear; i++) {
    let monthlyInterest = (yearIndex === 0 && i === 1) ? 0 : Math.round((investmentSize - paid.paid) * interestPerMonth);
    let payment = -Math.round(ExcelFormulas.PPMT(interestPerMonth, i + prevYearMonths,
                                                 leasingMonths, investmentSize, -monthlyInterest,
                                                 investmentSize * -residualValue, 1));
    paid.paid += payment;

    let residual = (prevYearMonths + i === leasingMonths) ? investmentSize * residualValue : 0;
    let residualInterest = (prevYearMonths + i === leasingMonths) ? Math.round((investmentSize - paid.paid) * interestPerMonth) : 0;
    // We first remove the residual interest since we do not want to include it to the payment (lyhennys)
    if (prevYearMonths + i === leasingMonths) payment += residual - residualInterest;
    // Then we add the residual intereset to the monthly payment since it is part of the payment
    months[i] = payment + monthlyInterest + residualInterest;
  }

  return months;
}

export default CalculatePayments;
